<script setup></script>
<script>
export default {
    name: 'QuestionMathPrimeFactorsViewOnly',
    components: {},
    props: {
        question: {
            required: true,
        },
    },
};
</script>

<template>
    <div>
        {{ question.options.number }}
    </div>
</template>
